import { z } from "zod";
import type { Category } from "./api";

// Lekki moduł: trasy wyszukiwarki i czatu (adres powrotu `back`) nie ciągną komponentu strony.

export type SearchSort = "date" | "relevance";

export interface SearchPageSearch {
	q?: string;
	idfirm?: number;
	from?: string;
	to?: string;
	category?: Category;
	/** Brak = „Najnowsze”. */
	sort?: SearchSort;
}

const date = z
	.string()
	.regex(/^\d{4}-\d{2}-\d{2}$/)
	.optional()
	.catch(undefined);

/** Parametry wyszukiwarki w URL-u — także adres powrotu z czatu (`back`). */
export const searchPageSchema = z.object({
	q: z.union([z.string(), z.number()]).transform(String).optional().catch(undefined),
	idfirm: z.number().int().positive().optional().catch(undefined),
	from: date,
	to: date,
	category: z.enum(["apteki", "robaczek", "alerty", "pomysly"]).optional().catch(undefined),
	sort: z.enum(["date", "relevance"]).optional().catch(undefined),
});
